<template>
  <div>
    <b-card id="wts-card" no-body small>
      <b-tabs id="wts-tabs" class="wt-sequencial-tab" v-model="tabIndex">
        <!-- PROCESS -->
        <b-tab id="wts-tab" :disabled="tabDisabledProcess">
          <template slot="title">{{tabProcess}}</template>

          <wtForm>
            <template slot="left">
              <BpmProcessFilter></BpmProcessFilter>
            </template>

            <template slot="right">
              <BpmProcess></BpmProcess>
            </template>
          </wtForm>
        </b-tab>
        <!-- VERSION -->
        <b-tab id="wts-tab" :disabled="tabDisabledVersion">
          <template slot="title">
            {{tabVersion}}
            <span
              v-if="!tabDisabledVersion"
              @click="closeVersion"
              class="tab-close-btn"
            >
              <i class="fas fa-times"></i>
            </span>
          </template>

          <wtForm>
            <template slot="left">
              <BpmProcessVersionFilter></BpmProcessVersionFilter>
            </template>

            <template slot="right">
              <BpmProcessVersion @attTabNavigation="tabNavigation"></BpmProcessVersion>
            </template>
          </wtForm>
        </b-tab>
        <!-- TASK -->
        <b-tab id="wts-tab" :disabled="tabDisabledTask">
          <template slot="title">
            {{tabTask}}
            <span v-if="!tabDisabledTask" @click="closeTask" class="tab-close-btn">
              <i class="fas fa-times"></i>
            </span>
          </template>

          <wtForm>
            <template slot="left">
              <BpmProcessTaskFilter></BpmProcessTaskFilter>
            </template>

            <template slot="right">
              <BpmProcessTask @attTabNavigation="tabNavigation"></BpmProcessTask>
            </template>
          </wtForm>
        </b-tab>
        <!-- COLUMN -->
        <b-tab id="wts-tab" :disabled="tabDisabledColumn">
          <template slot="title">
            {{tabColumn}}
            <span v-if="!tabDisabledColumn" @click="closeColumn" class="tab-close-btn">
              <i class="fas fa-times"></i>
            </span>
          </template>

          <wtForm>
            <template slot="left">
              <BpmTaskColumnFilter></BpmTaskColumnFilter>
            </template>

            <template slot="right">
              <BpmTaskColumn @attTabNavigation="tabNavigation"></BpmTaskColumn>
            </template>
          </wtForm>
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
/** COMPONENTS - LAYOUT **/

import wtForm from "@/components/forms/wtForm";

/** COMPONENTS **/
import BpmProcess from "@/modules/chameleon_ds/internal/bpm_process/BpmProcess";
import BpmProcessFilter from "@/modules/chameleon_ds/internal/bpm_process/BpmProcessFilter";

import BpmProcessVersion from "@/modules/chameleon_ds/internal/bpm_process/bpm_process_version/BpmProcessVersion";
import BpmProcessVersionFilter from "@/modules/chameleon_ds/internal/bpm_process/bpm_process_version/BpmProcessVersionFilter";

import BpmProcessTask from "@/modules/chameleon_ds/internal/bpm_process/bpm_process_task/BpmProcessTask";
import BpmProcessTaskFilter from "@/modules/chameleon_ds/internal/bpm_process/bpm_process_task/BpmProcessTaskFilter";

import BpmTaskColumn from "@/modules/chameleon_ds/internal/bpm_process/bpm_task_column/BpmTaskColumn";
import BpmTaskColumnFilter from "@/modules/chameleon_ds/internal/bpm_process/bpm_task_column/BpmTaskColumnFilter";

export default {
  name: "BpmProcessContainer",
  components: {
    wtForm,
    BpmProcess,
    BpmProcessFilter,
    BpmProcessVersion,
    BpmProcessVersionFilter,
    BpmProcessTask,
    BpmProcessTaskFilter,
    BpmTaskColumn,
    BpmTaskColumnFilter
  },
  computed: {
    showGrid() {
      return this.$store.state.layout.showGrid;
    },
    showFilter() {
      return this.$store.state.toolbars.showFilter;
    },
    objSelected() {
      return this.$store.state.objSelected;
    },
    objProcess() {
      return this.$store.state.objProcess;
    }
  },

  data: function() {
    return {
      tabIndex: 0,
      tabProcess: "Process",
      tabVersion: "",
      tabTask: "",
      tabColumn: "",
      tabDisabledProcess: false,
      tabDisabledVersion: true,
      tabDisabledTask: true,
      tabDisabledColumn: true
    };
  },
  methods: {
    tabNavigation() {
      /**
       * @tabNavigation É RESPONSÁVEL PELO ARMAZENAMENTO DE DADOS E NAVEGAÇÃO AUTOMATICA
       * APÓS INTERAÇÕES REALIZADAS NO PAINEL
       *
       * WATCHERS: @objSelected
       */

      /**
       * CONFIRMA SEMPRE SE A URL DE TRATAMENTO É A MESMA DA ATIVA, PARA EVITAR CONFLITOS
       * ESSE TRECHO APENAS SALVA AS INFORMAÇÕES SELECIONADAS NO OBJETO @objProcess
       */
      if (this.urlServicesStore === this.urlServices) {
        let newObj = this.objProcess;

        /**
         * CASO A TELA ATUAL SEJA A PROCESS E HOUVER CONTEUDO EM @objSelected
         * SALVA AS INFORMAÇÕES EM @objProcess _ @version_data
         */
        if (this.tabIndex == 0) {
          if (Object.entries(this.objSelected).length === 0) {
            newObj = null;
          } else {
            newObj = { process_data: this.objSelected };
          }
        }

        /**
         * CASO A TELA ATUAL SEJA A VERSION E HOUVER CONTEUDO EM @objSelected
         * SALVA AS INFORMAÇÕES EM @objProcess _ @version_data
         */
        if (this.tabIndex == 1) {
          if (Object.entries(this.objSelected).length === 0) {
            newObj = {
              process_data: this.objProcess.process_data
            };
          } else {
            newObj = {
              process_data: this.objProcess.process_data,
              version_data: this.objSelected
            };
          }
        }

        if (this.tabIndex == 2) {
          if (Object.entries(this.objSelected).length === 0) {
            newObj = {
              process_data: this.objProcess.process_data,
              version_data: this.objProcess.version_data
            };
          } else {
            newObj = {
              process_data: this.objProcess.process_data,
              version_data: this.objProcess.version_data,
              task_data: this.objSelected
            };
          }
        }

        this.$store.commit("setObjProcess", null);
        this.$store.commit("setObjProcess", newObj);
      }

      /**
       *
       * CONTROLE DE TAB ATIVA
       * O TITULO É LIMPO E A TAG DESATIVADA CASO NÃO HAJA DADOS PARA MOSTRAR
       * A TAB DE PROCESSOS SEMPRE FICARÁ ATIVA
       *
       */
      let objProcessEmpty = false;

      //objProcess existe
      if (this.objProcess) {
        //process_data EXISTE
        if (this.objProcess.process_data) {
          //version_data NÃO existe
          if (!this.objProcess.version_data) {
            this.tabDisabledVersion = false;
            this.tabDisabledTask = true;
            this.tabDisabledColumn = true;

            this.tabProcess = this.objProcess.process_data.bpm_process_data.process_label;
            this.tabVersion = "Version";
            this.tabTask = "";
            this.tabColumn = "";

            this.$nextTick(() => {
              this.tabIndex = 1;
            });

            //version_data EXISTE
          } else {
            //task_data NÃO existe
            if (!this.objProcess.task_data) {
              this.tabDisabledVersion = false;
              this.tabDisabledTask = false;
              this.tabDisabledColumn = true;

              this.tabProcess = this.objProcess.process_data.bpm_process_data.process_label;
              this.tabVersion = this.objProcess.version_data.bpm_process_version_data.version_number;
              this.tabTask = "Task";
              this.tabColumn = "";

              this.$nextTick(() => {
                this.tabIndex = 2;
              });

              //task_data EXISTE
            } else {
              this.tabDisabledVersion = false;
              this.tabDisabledTask = false;
              this.tabDisabledColumn = false;

              this.tabProcess = this.objProcess.process_data.bpm_process_data.process_label;
              this.tabVersion = this.objProcess.version_data.bpm_process_version_data.version_number;
              this.tabTask = this.objProcess.task_data.bpm_task_data.task_label;
              this.tabColumn = "Input";

              this.$nextTick(() => {
                this.tabIndex = 3;
              });
            }
          }
        } else {
          objProcessEmpty = true;
        }
      } else {
        objProcessEmpty = true;
      }

      //process_data NÃO existe ou NÃO foi INICIADO
      if (objProcessEmpty) {
        this.tabDisabledVersion = true;
        this.tabDisabledTask = true;
        this.tabDisabledColumn = true;

        this.tabProcess = "BPM Process";
        this.tabVersion = "";
        this.tabTask = "";
        this.tabColumn = "";

        this.$nextTick(() => {
          this.tabIndex = 0;
        });
      }
    },

    /* Clear Selected Process Data */
    closeVersion() {
      this.$store.commit("setObjProcess", {});
      this.$store.commit("setObjSelected", {});
    },

    /* Clear Selected Version Data */
    closeTask() {
      let newObj = this.objProcess;
      newObj = {
        process_data: newObj.process_data
      };
      this.$store.commit("setObjProcess", newObj);
      this.$store.commit("setObjSelected", {});
    },

    /* Clear Selected Task Data */
    closeColumn() {
      let newObj = this.objProcess;
      newObj = {
        process_data: newObj.process_data,
        version_data: newObj.version_data
      };
      this.$store.commit("setObjProcess", newObj);
      this.$store.commit("setObjSelected", {});
    }
  },
  watch: {
    objSelected() {
      this.tabNavigation();
    },
    tabIndex() {
      /* Switch data and reset panel */
      this.objItem = {};
      this.objItemData = {};

      switch (this.tabIndex) {
        case 0:
          this.$store.commit(
            "setUrlServicesStore",
            "chameleon-ds/api/internal/bpm-process"
          );
          break;
        case 1:
          this.$store.commit(
            "setUrlServicesStore",
            "chameleon-ds/api/internal/bpm-process-version"
          );
          break;
        case 2:
          this.$store.commit(
            "setUrlServicesStore",
            "chameleon-ds/api/internal/bpm-task"
          );
          break;
        case 3:
          this.$store.commit(
            "setUrlServicesStore",
            "chameleon-ds/api/internal/bpm-task-column"
          );
          break;
        default:
        /* Nothing */
      }

      this.$nextTick(() => {
        this.$store.commit("setShowGrid", true);
        this.$store.commit("setAction", "reset");
      });
    }
  },
  mounted() {
    this.$store.commit("setObjProcess", {});
    this.$store.commit("setObjSelected", {});
  },
  created() {
    this.$store.commit("setTypeLayout", 2);
    this.$store.commit(
      "setUrlServicesStore",
      "chameleon-ds/api/internal/bpm-process"
    );
  },
  beforeDestroy() {
    this.$store.commit("setObjFilter", {});
    this.$store.commit("setResetFilter", false);
    this.$store.commit("setApplyFilter", false);
  }
};
</script>

<style>
</style>
